import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import {
  ISnInviteUsersData,
  ISnEditChannelDialogData,
  ISnChannelFormDialogData,
  SnInviteUsersDialogComponent,
  SnChannelFormDialogComponent,
  SnEditChannelFormDialogComponent,
} from '../components/dialogs';
import { SnChannel } from '../models';

@Injectable()
export class SnChatDialogsService {
  constructor(private readonly _matDialog: MatDialog) {}

  public openInviteUserDialog(config: MatDialogConfig<ISnInviteUsersData>): Observable<SnChannel> {
    return this._matDialog
      .open(SnInviteUsersDialogComponent, config)
      .afterClosed()
      .pipe(filter((channel: SnChannel) => !!channel));
  }

  public openEditChannelDialog(
    config: MatDialogConfig<ISnEditChannelDialogData>,
  ): Observable<SnChannel> {
    return this._matDialog
      .open(SnEditChannelFormDialogComponent, config)
      .afterClosed()
      .pipe(filter((targetChannel: SnChannel) => !!targetChannel?.id));
  }

  public openChannelFormDialog(
    config: MatDialogConfig<ISnChannelFormDialogData>,
  ): Observable<SnChannel> {
    return this._matDialog
      .open(SnChannelFormDialogComponent, config)
      .afterClosed()
      .pipe(filter((channel: SnChannel) => !!channel?.id));
  }
}
